import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "11.75 6 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M19.4243 18.3883H21.2657H22.0376C22.611 18.3212 23.052 17.8409 23.0741 17.26V16.5563V13.4397C23.0741 13.1828 22.9748 12.9593 22.8094 12.7918C22.644 12.6242 22.4235 12.5237 22.1699 12.5237C21.6737 12.5237 21.2657 12.937 21.2657 13.4397V15.8637C21.2657 16.2435 20.957 16.5563 20.5821 16.5563H19.4022C19.1486 16.5563 18.9281 16.6568 18.7627 16.8244C18.5973 16.9919 18.498 17.2265 18.498 17.4834C18.5091 17.9861 18.9281 18.3883 19.4243 18.3883Z",
        fill: "#4F0599"
      }),
      _createElementVNode("path", {
        d: "M20.6044 9.67517H18.763H17.9911C17.4177 9.74219 16.9766 10.2225 16.9546 10.8034V11.5072V14.6238C16.9546 14.8807 17.0538 15.1041 17.2192 15.2717C17.3846 15.4392 17.6052 15.5398 17.8588 15.5398C18.355 15.5398 18.763 15.1265 18.763 14.6238V12.1997C18.763 11.8199 19.0717 11.5072 19.4466 11.5072H20.6264C20.8801 11.5072 21.1006 11.4066 21.266 11.2391C21.4314 11.0715 21.5306 10.8369 21.5306 10.58C21.5306 10.0773 21.1006 9.67517 20.6044 9.67517Z",
        fill: "#4F0599"
      }),
      _createElementVNode("path", {
        d: "M21.0452 7.83199C23.1623 7.83199 24.8934 9.58578 24.8934 11.7305V19.2261C24.8052 19.7399 24.3972 20.1421 23.879 20.2091H18.9611C16.833 20.2091 15.1128 18.4665 15.1128 16.3105V9.03842C15.1128 8.36818 15.6421 7.83199 16.3037 7.83199H21.0452ZM21.0452 6H16.2927C14.6387 6 13.2935 7.36282 13.2935 9.03842V16.3105C13.2935 19.4718 15.8296 22.0411 18.9501 22.0411H23.9562C25.3896 21.9182 26.5474 20.7788 26.6908 19.3378V11.7305C26.7018 8.55808 24.1767 6 21.0452 6Z",
        fill: "#4F0599"
      })
    ], -1)
  ]))]))
}
export default { render: render }